import React, { useState, useRef, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

// Track uploaded images
const uploadedImages = new Map();

// ---------------------
// CUSTOM UPLOAD ADAPTER
// ---------------------
class UploadAdapter {
  constructor(loader, uploadUrl) {
    this.loader = loader;
    this.uploadUrl = uploadUrl;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("upload", file);

          fetch(this.uploadUrl, {
            method: "POST",
            body: formData,
          })
            .then((res) => res.json())
            .then((result) => {
              uploadedImages.set(result.url, result.id);

              resolve({
                default: result.url,
              });
            })
            .catch(reject);
        })
    );
  }

  abort() { }
}

function UploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new UploadAdapter(
      loader,
      editor.config.get("simpleUpload").uploadUrl
    );
  };
}

// ---------------------
// MAIN COMPONENT
// ---------------------

export default function TextEditor({
  initialData = "",
  onSave = null,
  onChange = null,
  uploadUrl = "/api/upload",
}) {
  const editorRef = useRef(null);
  const [content, setContent] = useState(initialData);
  const [saving, setSaving] = useState(false);

  // Prevent re-render loop
  useEffect(() => {
    setContent(initialData);
  }, [initialData]);

  const editorConfig = {
    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "blockQuote",
      "insertTable",
      "imageUpload",
      "undo",
      "redo",
    ],
    simpleUpload: {
      uploadUrl,
    },
    extraPlugins: [UploadAdapterPlugin],

    // ✅ VERY IMPORTANT FIX
    height: "300px",
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      if (onSave) await onSave(content);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "350px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: 6,
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          config={editorConfig}
          data={content}
          onReady={(editor) => {
            editorRef.current = editor;

            // ✅ CRITICAL FIX
            editor.ui.view.editable.element.style.minHeight = "300px";
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            setContent(data);

            if (onChange) onChange(data);
          }}
        />
      </div>

      {/* SAVE BUTTON */}

      {onSave && (
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            marginTop: 12,
            padding: "8px 16px",
            background: "#1677ff",
            color: "#fff",
            borderRadius: 6,
            border: "none",
          }}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      )}
    </div>
  );
}



// import React, { useState, useRef } from "react";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import axios from "axios";

// // Track uploaded images
// const uploadedImages = new Map();

// // ---------------------
// // CUSTOM UPLOAD ADAPTER
// // ---------------------
// class UploadAdapter {
//   constructor(loader, uploadUrl) {
//     this.loader = loader;
//     this.uploadUrl = uploadUrl;
//   }

//   upload() {
//     return this.loader.file.then(
//       (file) =>
//         new Promise((resolve, reject) => {
//           const formData = new FormData();
//           formData.append("upload", file);

//           fetch(this.uploadUrl, {
//             method: "POST",
//             body: formData,
//           })
//             .then((res) => res.json())
//             .then((result) => {
//               uploadedImages.set(result.url, result.id);

//               resolve({
//                 default: result.url,
//               });
//             })
//             .catch(reject);
//         })
//     );
//   }

//   abort() { }
// }

// function UploadAdapterPlugin(editor) {
//   editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
//     const url = editor.config.get("simpleUpload").uploadUrl;
//     return new UploadAdapter(loader, url);
//   };
// }

// // DELETE image from backend
// const deleteImageFromServer = async (id) => {
//   try {
//     await axios.delete(`http://localhost:5001/api/upload/${id}`);
//   } catch (error) {
//     console.error("Delete error:", error);
//   }
// };

// const extractImages = (editor) => {
//   const imgs = [];
//   const root = editor.model.document.getRoot();

//   for (const child of root.getChildren()) {
//     if (child.name === "image") {
//       imgs.push(child.getAttribute("src"));
//     }
//   }
//   return imgs;
// };

// export default function TextEditor({
//   initialData = "",
//   onSave = null,
//   onChange = null,
//   uploadUrl = "/api/upload",
//   onPageChange = null, // <-- NEW CALLBACK
// }) {
//   const [content, setContent] = useState(initialData);
//   const [page, setPage] = useState(""); // <-- Dropdown state
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");

//   const previousImagesRef = useRef([]);
//   const editorRef = useRef(null);

//   const editorConfig = {
//     toolbar: [
//       "heading",
//       "|",
//       "bold",
//       "italic",
//       "link",
//       "bulletedList",
//       "numberedList",
//       "blockQuote",
//       "insertTable",
//       "undo",
//       "redo",
//       "imageUpload",
//     ],
//     simpleUpload: {
//       uploadUrl,
//     },
//     extraPlugins: [UploadAdapterPlugin],
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     setError("");

//     try {
//       if (onSave) await onSave(content, page); // <-- send page also
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="p-4">
//       {/* ========= CKEDITOR ========== */}
//       <CKEditor
//         editor={ClassicEditor}
//         config={editorConfig}
//         data={initialData}
//         onReady={(editor) => {
//           editorRef.current = editor;
//           previousImagesRef.current = extractImages(editor);
//         }}
//         onChange={(event, editor) => {
//           const html = editor.getData();
//           setContent(html);

//           if (onChange) onChange(html);

//           const currentImages = extractImages(editor);
//           previousImagesRef.current = currentImages;
//         }}
//       />

//       {/* SAVE BUTTON */}
//       <button
//         onClick={handleSave}
//         disabled={saving}
//         style={{
//           marginTop: 12,
//           padding: "8px 12px",
//           background: "#1677ff",
//           color: "#fff",
//           borderRadius: 6,
//           border: "none",
//         }}
//       >
//         {saving ? "Saving..." : "Save"}
//       </button>

//       {error && <p style={{ color: "red" }}>{error}</p>}
//     </div>
//   );
// }
